import { useLingui } from '@lingui/react/macro'
import { notifications } from '@mantine/notifications'
import type { QueryOptions } from '@markku/types'
import { trpc } from '../trpc'

export const customerHooks = {
  useList: () => trpc.customer.list.useQuery({}),
  useGetById: (id: number, options?: QueryOptions) =>
    trpc.customer.getById.useQuery(
      { id },
      { enabled: id > 0, staleTime: 5 * 60 * 1000, ...options },
    ),
  useUpdate: () => {
    const { t } = useLingui()
    const utils = trpc.useUtils()
    return trpc.customer.update.useMutation({
      onSuccess: () => {
        utils.customer.list.invalidate()
        notifications.show({
          title: t`Customer updated`,
          message: t`Customer updated successfully`,
          color: 'green',
        })
      },
      onError: (error) => {
        notifications.show({
          title: t`Error`,
          message: error.message || t`Failed to update customer`,
          color: 'red',
        })
      },
    })
  },
}
